// Module
var code = "<span>Why do we need this?</span> Powered Now needs your telephone number to\nput on your quotes, invoices and other documents. This can be turned off.\n";
// Exports
module.exports = code;